import { memo } from 'react'
import isEqual from 'react-fast-compare'
import { useSearchBox } from 'react-instantsearch'

export const VirtualSearchbox = memo(() => {
  useSearchBox()

  return null
}, isEqual)
